<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div class="container-fluid py-5" >
      <div class="row px-4 py-3">
        <div class="col-lg-12" >
          <app-linktree-top ></app-linktree-top>
        </div>
      </div>
      <div class="container">
        <div class="row">
            <div class="col-lg-12">
              <div class="card p-5">
              <div class="card-header">
                <h2>{{'tellAboutYourself' | translate}}</h2>
                <p>
                  {{'personalizedExperience' | translate}}
                </p>
              </div>

             <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control form-control-lg"
                  formControlName="interestInput"
                  [placeholder]="'enter_interests' | translate"
                />
                <button type="button" class="btn btn-primary mt-2" (click)="addInterest()">
                  {{'addInterest' | translate}}
                </button>
              </div>

              <!-- Error Message -->
              <div class="text-danger mb-3" *ngIf="errorMessage">
                {{ errorMessage }}
              </div>

              <!-- Pills Section -->
              <div class="mb-3">
                <h5>
                  {{"interests" | translate}}
                </h5>
                <div *ngIf="interests.length === 0" class="text-muted">
                  {{'noInterestsAdded' | translate}}
                </div>
                <div class="d-flex flex-wrap">
                  <span
                    *ngFor="let interest of interests"
                    class="badge bg-primary me-2 mb-2"
                    (click)="toggleSelection(interest)"
                    [class.bg-success]="isSelected(interest)"
                  >
                    {{ interest }} <button type="button" class="btn-close ms-2" aria-label="Close" (click)="removeInterest(interest)"></button>
                  </span>
                </div>
              </div>

              <!-- Submit Button -->
              <div class="d-grid mb-6">
                <button type="submit" class="btn btn-primary btn-lg smooth-shadow-lg" *ngIf="!loading">
                  {{"submit" | translate}}
                </button>
                <button type="submit" class="btn btn-primary btn-lg smooth-shadow-lg" *ngIf="loading">
                  <app-button-spinner></app-button-spinner>
                </button>
              </div>
            </form>

             </div>
          </div>
         </div>
       </div>
     </div>
  </section>
</main>

<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>